import { Component, input, inject } from '@angular/core';

import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TableRowData } from '@app/shared/models/table-data-types';
import {
    ColumnConfig,
    ColumnValue,
} from '@app/shared/services/view-configs/column-creator';

/**
 * Renders the bundle group status as a translated label, falling back to the
 * raw value when the status is not one of the known, translatable values.
 */
@Component({
    selector: 'app-bundle-group-status-display',
    template: `{{ getTranslatedStatus() }}`,
    standalone: true,
    imports: [TranslateModule],
})
export class BundleGroupStatusDisplayComponent {
    value = input<ColumnValue>();
    row = input<TableRowData>();
    column = input<ColumnConfig>();
    index = input<number>(0);
    parentRow = input<TableRowData>();

    private translateService = inject(TranslateService);

    getTranslatedStatus(): string {
        const status = this.value();
        if (!status) {
            return '';
        }
        return this.translateService.instant(
            `INCOMING-GOODS.BUNDLE-GROUPS.STATUSES.${status}`
        );
    }
}
